/* eslint-disable @typescript-eslint/naming-convention */
import pushClevertapEvent from '../pushClevertapEvent';
import formatDate from '../formatDate';

export function inventorySummaryStart({
  outletIds,
  startDate,
  endDate,
  namespace,
}) {
  pushClevertapEvent('Inventory Summary Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Current Inventory Filter': namespace,
  });
}
